import React from 'react';
import { NavLink } from 'react-router-dom';
import { NavIcon } from './NavIcon';

export function SidebarMenuGroup({ id, label, icon = 'list', isOpen, onToggle, children }) {
  return (
    <li className={`sidebar-menu-item-with-children${isOpen ? ' is-open' : ''}`}>
      <button
        type="button"
        className="sidebar-menu-label sidebar-menu-toggle"
        onClick={() => onToggle(id)}
        aria-expanded={isOpen}
        title={label}
        data-label={label}
      >
        <NavIcon name={icon} />
        <span className="nav-label">{label}</span>
        <span className="sidebar-menu-chevron" aria-hidden="true">{isOpen ? '▾' : '▸'}</span>
      </button>
      <ul className="sidebar-submenu">{children}</ul>
    </li>
  );
}

export function SideItem({ to, end, icon = 'list', children }) {
  const label = typeof children === 'string' ? children : undefined;
  return (
    <li>
      <NavLink to={to} end={end} title={label} data-label={label}>
        <NavIcon name={icon} />
        <span className="nav-label">{children}</span>
      </NavLink>
    </li>
  );
}

export function sectionMatchesPath(sectionId, pathname) {
  const rules = {
    clientes: {
      prefixes: ['/clientes', '/tipos-clientes', '/grupos', '/movimientos'],
      exclude: ['/movimientos-proveedores', '/movimientos-fondos', '/movimientos-predefinidos'],
    },
    proveedores: {
      prefixes: ['/proveedores', '/tipos-proveedores', '/movimientos-proveedores', '/gastos'],
    },
    fondos: {
      prefixes: [
        '/fondos',
        '/cierre-caja',
        '/cierres-caja',
        '/proyeccion-fondos',
        '/conciliacion-bancaria',
        '/movimientos-fondos',
        '/cartera-cheques',
        '/cheques-emitidos',
        '/formas-pago',
        '/cajas',
        '/bancos',
        '/cuentas-bancarias',
      ],
    },
    empleados: {
      prefixes: ['/empleados', '/tipos-movimiento-persona'],
    },
    informes: {
      prefixes: ['/informes', '/dashboard-fichas', '/whatsapp', '/proyeccion-fondos', '/resultados-reales'],
    },
    movimientos: {
      prefixes: ['/movimientos-programados', '/movimientos-predefinidos'],
    },
    seguridad: {
      prefixes: ['/usuarios', '/auditoria', '/backups'],
    },
    configuracion: {
      prefixes: ['/configuracion', '/admin/puesta-en-marcha'],
    },
  };

  const rule = rules[sectionId];
  if (!rule) return false;

  if (rule.exclude?.some((ex) => pathname === ex || pathname.startsWith(`${ex}/`))) {
    return false;
  }

  return rule.prefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export function openSectionsForPath(pathname) {
  const ids = ['clientes', 'proveedores', 'fondos', 'empleados', 'informes', 'movimientos', 'configuracion', 'seguridad'];
  const open = {};
  ids.forEach((id) => {
    if (sectionMatchesPath(id, pathname)) open[id] = true;
  });
  return open;
}
